function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pin_1_",
  "data-name": "pin (1)",
  transform: "translate(-5.886 -0.998)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_37303",
  "data-name": "Path 37303",
  d: "M11.558,17.066c.044.056.087.118.145.2.341.458.675.908,1,1.377l.629.888a.786.786,0,0,0,1.283,0l.918-1.295c.23-.322.468-.643.734-.986.041-.06.083-.115.146-.195.913-1.191,1.9-2.326,3.1-3.666a7.436,7.436,0,1,0-10.873.219,35.17,35.17,0,0,1,2.916,3.453ZM13.977,5.323a3.258,3.258,0,1,1-3.254,3.254,3.258,3.258,0,0,1,3.254-3.254Z",
  transform: "translate(-0.656 0)",
  fill: "#07abb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_37304",
  "data-name": "Path 37304",
  d: "M15.542,11.873a1.686,1.686,0,1,0-1.682-1.69,1.686,1.686,0,0,0,1.682,1.69Z",
  transform: "translate(-2.221 -1.605)",
  fill: "#07abb8"
}));

function SvgMarkerBtn(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.869,
    height: 18.868,
    viewBox: "0 0 14.869 18.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBtn);
export default __webpack_public_path__ + "static/media/marker-btn.ae9921a7.svg";
export { ForwardRef as ReactComponent };